module.exports = __webpack_public_path__ + "static/media/alert.10666d0a.svg";